var T;(function(T){T[T["UP"]=0]="UP";T[T["RIGHT"]=1]="RIGHT";T[T["DOWN"]=2]="DOWN";T[T["LEFT"]=3]="LEFT"})(T||(T={}));export{T as ECaretDirection};
//# sourceMappingURL=enums.js.map
